/** Matches backend `CustomerRegister` / `_validate_password` (models.py). */
export function validateCustomerPassword(password) {
    if (!password || password.length < 8) {
        return 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες';
    }
    if (!/[A-Z]/.test(password)) {
        return 'Ο κωδικός πρέπει να περιέχει τουλάχιστον ένα κεφαλαίο γράμμα (A–Z)';
    }
    if (!/[a-z]/.test(password)) {
        return 'Ο κωδικός πρέπει να περιέχει τουλάχιστον ένα πεζό γράμμα (a–z)';
    }
    if (!/[0-9]/.test(password)) {
        return 'Ο κωδικός πρέπει να περιέχει τουλάχιστον έναν αριθμό';
    }
    return null;
}
